// RCPT1-S3 (design/mockups/rcpt1-s3/closeout-awaiting-tip.html; the line itself is RCPT1-S4's, read by src/domain/receiptTipSweep.ts). The
// closeout's Awaiting tip block: one warning figure (the authorized total and how many tickets) and the tickets under it. Authorized
// card sales not yet captured are NOT sales and NOT tips, so this sits apart from both. Hidden when there are none (absent is honest).
// All text via textContent; the figures are the server's.

import type { CloseoutSummaryDto } from "./api.ts";
import { formatCents } from "./money.ts";

function el(tag: string, className: string, testid?: string, text?: string): HTMLElement {
  const node = document.createElement(tag);
  if (className !== "") node.className = className;
  if (testid !== undefined) node.dataset["testid"] = testid;
  if (text !== undefined) node.textContent = text;
  return node;
}

const dayText = (iso: string): string => {
  const [year, month, day] = iso.split("-").map(Number);
  if (year === undefined || month === undefined || day === undefined) return iso;
  return new Date(Date.UTC(year, month - 1, day)).toLocaleDateString([], {
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  });
};

/** Fills the Awaiting tip host from the summary, or hides it. */
export function renderCloseoutAwaitingTip(host: HTMLElement, summary: CloseoutSummaryDto): void {
  host.replaceChildren();
  const line = summary.awaitingTip;
  host.hidden = line === undefined || line.count === 0;
  if (line === undefined || line.count === 0) return;

  const grid = el("div", "figure-grid", "closeout-awaiting-tip-grid");
  const card = el("div", "figure-card", "closeout-awaiting-tip-card");
  card.style.borderColor = "var(--color-warning-subtle-border)";
  card.style.background = "var(--color-warning-subtle)";
  const label = el("div", "figure-card-label", undefined, "Awaiting tip");
  label.style.color = "var(--color-warning-strong)";
  label.style.fontWeight = "700";
  card.append(
    label,
    el("div", "figure-card-value", "closeout-awaiting-tip-amount", formatCents(line.amountCents)),
    el(
      "div",
      "figure-card-note",
      "closeout-awaiting-tip-count",
      `${line.count} ticket${line.count === 1 ? "" : "s"}`,
    ),
  );
  grid.append(card);

  const heading = el("h2", "section-title", undefined, "Awaiting tip ");
  heading.append(el("span", "section-count", undefined, String(line.count)));
  const list = el("div", "list-card", "closeout-awaiting-tip-list");
  for (const ticket of line.tickets) {
    const row = el("div", "unresolved-row", "closeout-awaiting-tip-row");
    const main = el("div", "unresolved-main");
    const detail =
      ticket.carriedToBusinessDate === null
        ? dayText(ticket.businessDate)
        : `${dayText(ticket.businessDate)} · carried to ${dayText(ticket.carriedToBusinessDate)}`;
    main.append(
      el("div", "unresolved-name", undefined, ticket.name ?? "Unnamed tab"),
      el("div", "unresolved-detail", undefined, detail),
    );
    const amount = el("div", "unresolved-amount");
    amount.append(el("div", "unresolved-amount-value", undefined, formatCents(ticket.amountCents)));
    row.append(main, amount);
    list.append(row);
  }
  host.append(grid, heading, list);
}
